import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {Router} from "@angular/router";
import {AuthInfo} from "../shared/security/auth-info";
import {AuthService} from "../shared/security/auth.service";
import {Overlay} from "angular2-modal";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {validateEmail} from "../shared/validators/validate-email";
import {UUID} from "angular2-uuid";
import {InvitationCode} from "../shared/model/invitation-code";
import {DatePipe} from "@angular/common";


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']

})
export class HomeComponent implements OnInit {
  codeError: string;
  iscodeError: boolean;
  accessCode: string;

  authInfo:AuthInfo;
  form:FormGroup;
  private isVerified : boolean;
  private isLogedIn  : string;
  isBeta: boolean = false;
  // isBeta: boolean = false;
  //  Should be true before deploying to production
  private myBrowser:string;
  private inviteCode : InvitationCode;
  private anonymusUser: any;
  private browser: any;

  constructor(
    private router:Router,
    private authService:AuthService,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,
    private fb: FormBuilder,
    private datePipe: DatePipe,

  ) {

    this.form = this.fb.group({
      email:['',[Validators.required, validateEmail]],
      code:['',[Validators.required,Validators.minLength(6)]]
    });
    overlay.defaultViewContainer = vcRef;
    this.inviteCode = Object.assign({});

    // console.log("Home Componenet!");

  }

  ngOnInit() {

    this.myBrowser = window.navigator.userAgent;

    // console.log(this.myBrowser);
    this.authService.logout();

    this.authService.anonymously().subscribe(
      user =>
      {
        this.anonymusUser = user;
        // console.log(user);
        let flatObj = this.flattenObject(user.g);
        for (let y in flatObj){
          // console.log(y);
          if (y=='Pd_X_Client_Version'){
            this.browser = flatObj[y];
             // console.log(flatObj[y]);
          }

        }
        // this.browser = flatObj.Pd_X_Client_Version;
      }
    )
  }

  onRequesCode() {

    // console.log("Requesting Invite ");



    // console.log(partOfUuid);

    let myDy = String(new Date().getTime() / 1000);

    this.inviteCode.adminUser='';
    this.inviteCode.code='';
    this.inviteCode.createdDateTime = this.formattDate(myDy);
    this.inviteCode.emailSent =false;
    this.inviteCode.userEmail=this.form.value.email;
    this.inviteCode.emailSentDate = '';
    this.inviteCode.usedDateTime = '';
    this.inviteCode.browser = this.browser;
    this.inviteCode.requesterUserId = this.anonymusUser.uid;

    this.authService.createInviteCode(this.inviteCode).subscribe(
      // result => console.log(result)
      ()=>{

        this.messageIt('Thank you for inquiring!','An invitation code will be sent to your inbox soon (Based on availability)')

      }
    )



  }

  joinBeta() {
    // console.log("Joining Beta ");
    this.authService.getCode(this.form.value.code).subscribe(
      rest => {
        // console.log(rest);
        // console.log(rest.length);
        if (rest.length == 0){
          this.codeError = 'Invalid Code, please check your code and try again!';
          this.iscodeError = true;
        } else {
          this.inviteCode =rest[0];
          if (!this.inviteCode.usedDateTime){
            // console.log('not used');
            let myDy = String(new Date().getTime() / 1000);
            this.inviteCode.usedDateTime = this.formattDate(myDy);
            this.authService.markCodeAsUsed(this.inviteCode).subscribe(
              ()=>{this.isBeta = false;}
            )
          } else {
            // console.log('used');
            this.codeError = 'this code has already been redeemed';
            this.iscodeError = true;
          }
        }
      }
    )
  }

  formattDate(dt){
    // dateFormat(ret, "dddd, mmmm dS, yyyy, h:MM:ss TT");
    let ret = this.datePipe.transform(new Date(dt * 1000), 'medium');
    // ret = {{ret | date: 'dd/MM/yyyy H:mm' }}
    return ret
  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
  }

  showEmailErrors(){
    if (this.form.controls['email'].errors){
      this.form.controls['email'].markAsDirty();
    }

  }

  isEmailValid():boolean{
    return !this.form.controls['email'].errors
  }

  itHaveErrors(){
    return this.form.valid;
  }

  ngOnChange(){
    // this.logIt('changeDetected');
  }

  private logIt(msg: string) {
    // console.log(`${msg}`);
  }

  ngAfterContentInit() {
    // this.logIt('AfterContentInit');
  }

  ngAfterContentChecked() {
    // contentChild is updated after the content has been checked
  }

  ngAfterViewInit() {
    // viewChild is set after the view has been initialized
    // this.logIt('AfterViewInit');
  }

  /*

  ngAfterViewChecked() {
    // viewChild is updated after the view has been checked
      this.logIt('AfterViewChecked');
  }

  */

/*

 checkForEmailChange(){
      const userNonAnonimus$ = this.authService.authInto$;
      userNonAnonimus$
        .subscribe( (user) =>
        {
          console.log(user);
          // if (user.$uid !== null) {
          //   console.log(user.verified);
          //   if (user.verified) {
          //     this.router.navigate(['/restaurants']);
          //   } else {
          //     this.showemailVerificationMessage().then(() => {}).catch((ex) => {console.log('error sending message ', ex)})
          //   }
          // }
        });
 }

*/

  navigateToRegister(){
    this.router.navigate(['register']);
  }

  navigateToLogin() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  openModal(){
    this.messageIt('Modal Test','Test successfully! ');
  }

  messageIt(titleP:string,messageP:string){

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

  // messageIt('Verify your email','Please check you Mailbox a Verification Email !');

  resendDialog(){
    this.modal.confirm()
      .size('lg')
      .isBlocking(true)
      .showClose(true)
      .keyboard(27)
      .title('Verify your email')
      .body('<p>You must verify your Email address to gain full access to all system!</p> Please check your Mailbox for a Verification mail from SRVPLS !')
      .okBtn('Resend Confirmation Email')
      .cancelBtn('Ok')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => {return dialog.result; })
      .then((result: any) => { this.resendVerification();this._cleanup()})
      .catch((err: any) => this._cleanup())

    ;
  }

  _cleanup(){
    // console.log("Cleaning Up!")
    // this.checkforEmailVerificationChange();
    this.navigateToLogin();
  }

  emailSentDialog(){
    this.modal.alert()
      .size('lg')
      .isBlocking(true)
      .showClose(true)
      .keyboard(27)
      .title('Verify your email')
      .body('Please check your Mailbox for a Verification mail from SRVPLS !')
      .okBtn('OK')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => {return dialog.result; })
      .then((result: any) => { this._cleanup()})
      // .catch((err: any) => this._cleanup())

    ;
  }

  logThis(thisParm="Emptty"){
    // console.info(thisParm);
  }

  resendVerification(){
    // console.log("Resending Verification");
    const emailVerification$ = this.authService.sendVerificationEmmail();
    emailVerification$.subscribe(
      ()=>{},
      err => this.messageIt('Password verification',err)
    )
    this.emailSentDialog();
  }

  flattenObject(ob) {
    let toReturn = {};

    for (let i in ob) {
      if (!ob.hasOwnProperty(i)) continue;

      if ((typeof ob[i]) == 'object') {
        let flatObject = ob[i];
        for (let x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) continue;


          if(flatObject[x].constructor == Array){
            for (let y in flatObject[x]){
              // console.log(y)
              if ((typeof flatObject[x][0]) == 'object') {
                let flatObjectInt = this.flattenObject(flatObject[x][0]);
                for (let z in flatObjectInt){
                  toReturn[i+'_'+y+'_'+z] = flatObjectInt[z]
                }
              } else {
                toReturn[i + '_' + y] = flatObject[x][0];
              }

            }

          } else {
            toReturn[i + '_' + x.replace(/-/g,'_')] = flatObject[x];
          }
        }
      } else {
        toReturn[i] = ob[i];
      }
    }
    return toReturn;
  };

  isCodeError() {
    return this.iscodeError;
  }

  clearBetaError() {
    this.iscodeError = false;
  }
}

// DONE :Change the alerts for Moodal Messages



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts